import axios from '@/plugins/axios';
import { OPERATION_TYPE } from './constants';

class DeviceManageLogApi {
  static getLogs(
    page = 1,
    limit = 10,
    type = OPERATION_TYPE.ALL,
    productNo = '',
    produceNo = '',
    optNickName = '',
  ) {
    return axios({
      url: '/api/sys/log/product/page',
      data: {
        page,
        limit,
        type,
        product_no: productNo,
        produce_no: produceNo,
        opt_nick_name: optNickName,
      },
      method: 'post',
      headers: {
        meta: {
          skipSuccess: true,
          desc: '查询设备管理日志',
        },
      },
    });
  }

  static export(data) {
    return axios({
      url: '/api/sys/log/product/export',
      method: 'post',
      data,
      headers: {
        meta: {
          skipSuccess: true,
          desc: '导出',
        },
      },
    });
  }
}

export default DeviceManageLogApi;
